import { render, staticRenderFns } from "./applicationDetails.vue?vue&type=template&id=2c44a60d&scoped=true&"
import script from "./applicationDetails.vue?vue&type=script&lang=js&"
export * from "./applicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./applicationDetails.vue?vue&type=style&index=0&id=2c44a60d&prod&vars=%7B%20'sidebar-width'%20%7D&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44a60d",
  null
  
)

export default component.exports